import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

import SectionTitle from "../home/SectionTitle";

import movesCity from "../../img/markets/moves-city.webp";
import movesCoins from "../../img/markets/moves-coins.webp";
import movesWallst from "../../img/markets/moves-wallst.webp";

const STEPS = ["markets.moves.step1", "markets.moves.step2", "markets.moves.step3"];

function ThreeMoves() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[56px] items-center lg:items-start">
          {/* Коллаж (только desktop) */}
          <Fade triggerOnce direction="left" duration={700} className="hidden lg:block w-[51.3%] shrink-0">
          <div className="relative w-full aspect-[626/494]">
            {/* Город — верх слева */}
            <div className="absolute left-0 top-0 w-[45.7%] h-[57.1%] rounded-[20px] overflow-hidden">
              <img src={movesCity} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>

            {/* Серая карточка с монетами — по центру */}
            <div className="absolute left-[49.7%] top-[8.9%] w-[50.3%] h-[78.5%] rounded-[20px] bg-[#f2f2f1]">
              <div className="absolute inset-[30px] overflow-hidden">
                <img
                  src={movesCoins}
                  alt=""
                  aria-hidden
                  className="absolute w-[205.3%] max-w-none left-[-21.6%] top-[-44.1%]"
                />
              </div>
            </div>

            {/* Wall St — низ слева */}
            <div className="absolute left-0 top-[62.1%] w-[45.7%] h-[37.9%] rounded-[20px] overflow-hidden">
              <img src={movesWallst} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>
          </div>
          </Fade>

          {/* Контент справа */}
          <div className="flex flex-col items-center flex-1 w-full lg:pt-[44px]">
            <SectionTitle
              title1={t("markets.moves.title1")}
              title2={t("markets.moves.title2")}
              text={t("markets.moves.subtitle")}
              className="max-w-[525px]"
            />

            {/* Шаги */}
            <div className="mt-[30px] lg:mt-[35px] w-full max-w-[523px] flex gap-[6px] lg:gap-[9px]">
              {STEPS.map((key) => (
                <div
                  key={key}
                  className="flex-1 flex items-center justify-center bg-[#f8faff] rounded-[20px] py-[20px] px-[6px]"
                >
                  <span className="font-['Inter'] font-normal text-[13px] sm:text-[16px] text-[#435c7f] text-center">
                    {t(key)}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA — только desktop, в мобильном макете кнопки нет */}
            <a
              href={link}
              className="hidden lg:inline-flex mt-[48px] items-center justify-center px-[42px] py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
              style={{
                backgroundImage:
                  "linear-gradient(-84deg, rgba(14,28,54,0.8) 6%, rgba(3,65,180,0.8) 66%)",
              }}
            >
              {t("markets.moves.cta")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThreeMoves;
